export function getFileNameFromStem(stem: string): string {
    return stem.split('/').reverse()[0];
}